import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Invoices from "./pages/Invoices";
import Purchases from "./pages/Purchases";
import Customers from "./pages/Customers";
import Products from "./pages/Products";
import CompanyProfile from "./pages/CompanyProfile";
import InvoiceForm from "./components/InvoiceForm";
import Transactions from "./pages/Transactions";
import NonGst from "./pages/NonGst";
import Proforma from "./pages/Proforma";
import ProformaForm from "./components/ProformaForm";

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (email === "sales@digitalsmarttechnology.com" && password === "Digital@810") {
      localStorage.setItem("isAuth", "true");
      onLogin(true);
    } else {
      setErr("Invalid Email or Password");
    }
  };

  return (
    <div className="flex h-screen bg-gray-200 items-center justify-center">
      <form onSubmit={handleLogin} className="bg-white p-8 rounded-lg shadow-lg w-96 border-t-4 border-blue-600">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">DST Billing ERP</h1>
        </div>
        {err && <p className="text-red-500 text-sm mb-4 text-center font-bold bg-red-100 p-2 rounded">{err}</p>}
        <div className="mb-4"><label className="block text-sm font-bold mb-2">Email Address</label><input required type="email" className="w-full border-2 p-2 rounded" value={email} onChange={e=>setEmail(e.target.value)} /></div>
        <div className="mb-6"><label className="block text-sm font-bold mb-2">Password</label><input required type="password" className="w-full border-2 p-2 rounded" value={password} onChange={e=>setPassword(e.target.value)} /></div>
        <button type="submit" className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded">Secure Login</button>
      </form>
    </div>
  );
}

function Sidebar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  
  const handleLogout = () => {
    localStorage.removeItem("isAuth");
    window.location.reload();
  };

  return (
    <div className="w-64 bg-gray-900 text-white flex flex-col h-screen">
      <div className="p-4 text-xl font-bold border-b border-gray-800">DST Billing</div>
      <div className="p-4 pb-2">
        <Link to="/invoices/new" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-2 px-4 rounded-lg flex justify-center mb-2 shadow-lg">+ Tax Invoice</Link>
        <Link to="/proforma/new" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg flex justify-center shadow-lg">+ Proforma</Link>
      </div>
      <nav className="flex-1 px-4 py-2 space-y-1 overflow-y-auto">
        <Link to="/" className={`block px-4 py-2 rounded ${isActive('/') ? 'bg-blue-600' : 'hover:bg-gray-800'}`}>Dashboard</Link>
        
        <div className="text-gray-500 text-xs font-bold uppercase mt-4 mb-2 px-2">Sales & Income</div>
        <Link to="/invoices" className={`block px-4 py-2 rounded ${isActive('/invoices') ? 'bg-blue-600' : 'hover:bg-gray-800'}`}>Tax Invoices</Link>
        <Link to="/nongst" className={`block px-4 py-2 rounded ${isActive('/nongst') ? 'bg-green-600 font-bold' : 'hover:bg-gray-800 text-green-300'}`}>NON GST Received</Link>
        <Link to="/proforma" className={`block px-4 py-2 rounded ${isActive('/proforma') ? 'bg-indigo-600' : 'hover:bg-gray-800'}`}>Proforma</Link>
        
        <div className="text-gray-500 text-xs font-bold uppercase mt-4 mb-2 px-2">Purchases & Expenses</div>
        <Link to="/purchases" className={`block px-4 py-2 rounded ${isActive('/purchases') ? 'bg-blue-600' : 'hover:bg-gray-800'}`}>GST Purchases</Link>
        <Link to="/transactions" className={`block px-4 py-2 rounded ${isActive('/transactions') ? 'bg-red-600 font-bold' : 'hover:bg-gray-800 text-red-300'}`}>Office Expenses</Link>
        
        <div className="text-gray-500 text-xs font-bold uppercase mt-4 mb-2 px-2">Masters</div>
        <Link to="/customers" className={`block px-4 py-2 rounded ${isActive('/customers') ? 'bg-blue-600' : 'hover:bg-gray-800'}`}>Customers</Link>
        <Link to="/products" className={`block px-4 py-2 rounded ${isActive('/products') ? 'bg-blue-600' : 'hover:bg-gray-800'}`}>Products</Link>
        <Link to="/company" className={`block px-4 py-2 rounded ${isActive('/company') ? 'bg-blue-600' : 'hover:bg-gray-800'}`}>Company Profile</Link>
      </nav>
      <div className="p-4 border-t border-gray-800"><button onClick={handleLogout} className="w-full text-left px-4 py-2 text-red-400 hover:bg-gray-800 rounded font-bold">🚪 Logout</button></div>
    </div>
  );
}

export default function App() {
  const [isAuth, setIsAuth] = useState(localStorage.getItem("isAuth") === "true");
  if (!isAuth) return <Login onLogin={setIsAuth} />;

  return (
    <BrowserRouter>
      <div className="flex h-screen bg-gray-100 overflow-hidden">
        <Sidebar />
        <div className="flex-1 overflow-y-auto">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/invoices/new" element={<InvoiceForm />} />
            <Route path="/invoices/edit/:id" element={<InvoiceForm />} />
            <Route path="/proforma" element={<Proforma />} />
            <Route path="/proforma/new" element={<ProformaForm />} />
            <Route path="/proforma/edit/:id" element={<ProformaForm />} />
            <Route path="/purchases" element={<Purchases />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/nongst" element={<NonGst />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/products" element={<Products />} />
            <Route path="/company" element={<CompanyProfile />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
